"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var redux_observable_1 = require("redux-observable");
var epics_1 = require("utils/upload/epics");
var trmeterRemarkImages_1 = require("actions/trmeterRemarkImages");
var remark_1 = require("@caddigital/sok-reducers/lib/actions/trmvrmeterentries/remark");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var toast_1 = require("@caddigital/sok-reducers/lib/actions/toast");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var epics = (0, epics_1.createEpics)('@sok/web/sokosite/trmeter/remark', function (state) { return state.trmeterRemarkImages; });
var searchOptions = {
    sortBy: null,
    order: 'desc',
    limit: 350,
    offset: 0
};
var refreshRemarkImages = function (state) {
    return remark_1.ImagesFolderListActions.fetchRequest((state.trmvrmeterentries.remark.currentRemark &&
        state.trmvrmeterentries.remark.currentRemark.image_folder_id) ||
        0, searchOptions);
};
var refreshRemarkConfirmationImages = function (state) {
    return remark_1.ConfirmationImagesFolderListActions.fetchRequest((state.trmvrmeterentries.remark.currentRemark &&
        state.trmvrmeterentries.remark.currentRemark
            .confirmation_image_folder_id) ||
        0, searchOptions);
};
function toastOnRemarkSave(action$, store, _fetchOptions) {
    return action$.pipe((0, operators_1.filter)(function (action) {
        return [
            '@sok/trmvrmeterentries/remark/CREATE_REMARK_SUCCESS',
            '@sok/trmvrmeterentries/remark/CREATE_REMARK_FAILURE',
            '@sok/trmvrmeterentries/remark/UPDATE_REMARK_SUCCESS',
            '@sok/trmvrmeterentries/remark/UPDATE_REMARK_FAILURE'
        ].includes(action.type);
    }), (0, operators_1.mergeMap)(function (action) {
        var type = action.type.includes('SUCCESS') ? 'NORMAL' : 'FAILURE';
        var localizationKeyType = action.type.includes('SUCCESS')
            ? 'success'
            : 'failure';
        var title = (0, translation_1.getLocalization)("remark/save/".concat(localizationKeyType, "/title"));
        var message = (0, translation_1.getLocalization)("remark/save/".concat(localizationKeyType, "/message"));
        return (0, rxjs_1.of)((0, toast_1.addNewToast)(title, message, type, []));
    }));
}
exports.default = (0, redux_observable_1.combineEpics)(epics.checkDuplicateFolder, epics.initFileUpload, epics.handleFileUpload, epics.cancelUploadSession, epics.saveOnFileUploadDone(function (state) { return [
    refreshRemarkImages(state),
    refreshRemarkConfirmationImages(state),
    trmeterRemarkImages_1.default.fileuploadDone()
]; }, function (err) { return [{ type: '@sokosite/upload/error', payload: err }]; }), toastOnRemarkSave
// refreshOnDelete
);
